import { colours, sizes } from '@qflow/theme'
import { Flag } from 'portal/lib/primitives/icons'

export function ReviewFlag() {
  return <Flag colour={colours.ORANGE} size={sizes.MEDIUM} />
}
